// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","250":"3858332f","313":"e1869865","513":"011a8468","706":"711ede07","726":"759a3e6d"}[chunkId] + ".chunk.js";
};